import * as TrackingService from 'common/services/tracking.service';
import moment from 'moment';
import {
  SEARCH_DATE_FORMAT,
  SESSION_STORAGE_KEYS,
  TRACKING
} from 'common/constants/constants';
import { daysBetweenDates } from '@linearb/linui-utils';
import { momentDateValidator } from 'common/utils/time.utils';
import { getRetentionDaysByLicense } from 'common/utils/utils';
import { Flex } from 'components/base/layout-components';
import { getTeamsNames } from './TeamsDropdown';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import GranularityDropdown from './GranularityDropdown';
import { DORA_DASHBOARD_V2_EVENT_DATES_LIMIT_DAYS } from '../../../../dashboard/doraV2/dashboard.doraV2.freeTier.consts';
import { Filter30daysTooltip } from 'connected-components/TopBar/Filter30DaysTooltip';
import { cn, LBAlert, LBDateRangePicker } from '@linearb/buzz';

export const getNonEditModeFilters = ({
  isOnEditMode,
  retentionDays,
  license,
  filters,
  isCustom,
  isPmCustomDashboard,
  isAllControbutorsTeamSelected
}) => {
  if (isOnEditMode) {
    return [];
  }
  const { start_date, end_date } = filters.selectedTimeRanges;
  const tomorrow = moment().add(1, 'day').toDate();

  const isLessThan7days =
    daysBetweenDates(
      // @ts-ignore
      momentDateValidator(start_date),
      momentDateValidator(end_date)
    ) < 7;

  const DateRangePicker = (
    <LBDateRangePicker
      className={cn('[&>button]:border', {
        '[&>button]:border-orange-400': isLessThan7days
      })}
      mode='range'
      selected={{
        from: momentDateValidator(start_date).toDate(),
        to: momentDateValidator(end_date).toDate()
      }}
      disabled={[
        isAllControbutorsTeamSelected
          ? {
              before: moment()
                .subtract(DORA_DASHBOARD_V2_EVENT_DATES_LIMIT_DAYS, 'day')
                .toDate(),
              after: new Date()
            }
          : { after: tomorrow }
      ]}
      onSelect={selected => {
        if (!selected) {
          return;
        }

        const newTimeframe = {
          start_date: moment(selected.from).format(SEARCH_DATE_FORMAT),
          end_date: moment(selected.to).format(SEARCH_DATE_FORMAT)
        };

        TrackingService.logEvent(TRACKING.EVENTS.FILTER, {
          page: TRACKING.PAGES.METRICS,
          filter_name: TRACKING.FILTER.TIMEFRAME,
          ...(isCustom
            ? { page_tab: TRACKING.PAGE_TABS.CUSTOM_DASHBOARD }
            : {}),
          team_names: getTeamsNames(filters.globallySelectedTeams)
        });

        BrowserStorageAccessor().session.set(
          SESSION_STORAGE_KEYS.CUSTOM_DASHBOARD_TIMEFRAME,
          JSON.stringify(newTimeframe)
        );

        filters.setSelectedTimeRanges(newTimeframe);
      }}
    >
      {!isAllControbutorsTeamSelected &&
        retentionDays &&
        retentionDays === getRetentionDaysByLicense(license) && (
          <div className='p-2'>
            <LBAlert className='max-w-[480px]'>
              <p>
                Your license includes the last {retentionDays} days’ metrics.
                Upgrade your plan for more.
                <a
                  href='https://linearb.io/book-a-demo'
                  target='_blank'
                  referrerPolicy='no-referrer'
                >
                  Learn more
                </a>
              </p>
            </LBAlert>
          </div>
        )}
    </LBDateRangePicker>
  );

  return [
    <Flex key='DateRange'>
      {isLessThan7days ? (
        <Filter30daysTooltip>{DateRangePicker}</Filter30daysTooltip>
      ) : (
        DateRangePicker
      )}
    </Flex>,
    <GranularityDropdown
      key='GranularityDropdown'
      globallySelectedTeams={filters.globallySelectedTeams}
      selectedGranularity={filters.selectedGranularity}
      onChange={granularity =>
        filters.setSelectedGranularity(granularity || null)
      }
      isPmCustomDashboard={isPmCustomDashboard}
    />
  ];
};
